<template>
  <div class="pa-4">
    <portal to="app-header">
      <router-link
        to="/tableheadingstickycode"
        class="ml-2"
      >
        看看代码
      </router-link>
    </portal>
    <div class="d-flex align-center">
      <h1>表格表头固定</h1>
      <code
        class="mx-3"
        style="cursor: pointer;"
        @click="copyCss"
      >position: sticky;top: 0;</code>
      <span class="green--text lighten-2">{{ info }}</span>
    </div>
    <v-data-table
      :headers="headers"
      :items="items"
      :height="height"
      :items-per-page="-1"
      show-select
    />
  </div>
</template>

<script>

export default {
  data() {
    return {
      height: document.body.clientHeight - 200,
      items: [ ...Array(100)].map((v, i) => ({ id: i + 1, name: `张三${i + 1}`, code: i + 1 })),
      headers: [
        { text: 'id', value: 'id' },
        { text: 'name', value: 'name' },
        { text: 'code', value: 'code' },
      ],
      info: '',
    }
  },
  methods: {
    copyCss() {
      const code = 'position: sticky;top: 0;';
      const oInput = document.createElement('textarea');
      oInput.value = code;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      document.body.removeChild(oInput);
      this.info = '复制成功'
      setTimeout(() => {
        this.info = ''
      }, 2000)
    },
  },
}
</script>

<style scoped>
::v-deep thead.v-data-table-header {
  position: sticky;
  top: 0;
  /* 隐藏行选择checkbox */
  z-index: 9999;
}
/* 亮色模式 */
::v-deep .theme--light .v-data-table-header {
  background-color: rgb(253, 253, 253);
}
/* 暗色模式 */
::v-deep .theme--dark .v-data-table-header {
  background-color: rgb(50, 50, 50);
}
</style>